module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "locationboard-container"
  }, [_c('ul', {
    staticClass: "location-list"
  }, _vm._l((_vm.locationLst), function(location) {
    return _c('li', {
      key: location.id,
      staticClass: "location-item",
      on: {
        "click": function($event) {
          _vm.locate(location.center)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(location.name))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a30cccd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/toolbar/location-board.vue
// module id = 34
// module chunks = 0